import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import CompanyComponent from "../components/CompanyComponent";
import CompanyContainer from "../CompanyContainer";
import debtIcon from "../../../assets/design-revamp-company/equity-component/equity-icon.svg";
import { addDebtProjectToBusiness } from "../../../apis/Business/DebtProjectApi";
import Debt from "../Debt";

const AddDebt = () => {
  const urlParams = new URLSearchParams(window.location.search);
  const year = urlParams.get("year");
  const [vatNumber, setVatNumber] = useState("");
  const [countryOrigin, setCountryOrigin] = useState("");
  const [investeeName, setInvesteeName] = useState("");
  const [yourShare, setYourShare] = useState("");
  const [scope1, setScope1] = useState("");
  const [scope2, setScope2] = useState("");
  const [errorMessage, setErrorMessage] = useState({});
  const navigate = useNavigate();

  useEffect(() => {
    if (year == null || year === "") {
      navigate("/company");
    }
  }, [navigate, year]);

  const handleFormDataChange = (updatedFormData) => {
    setInvesteeName(updatedFormData.investeeName);
    setVatNumber(updatedFormData.vatNumber);
    setCountryOrigin(updatedFormData.countryOrigin);
    setYourShare(updatedFormData.yourShare);
    setScope1(updatedFormData.scope1);
    setScope2(updatedFormData.scope2);
  };

  const save = () => {
    addDebtProjectToBusiness({
      vat_num: vatNumber,
      investee_name: investeeName,
      country: countryOrigin,
      share_of_costs: yourShare,
      scope_1: scope1,
      scope_2: scope2,
      setErrorMessage: setErrorMessage,
      use_swal: true,
      callback: () =>
        setTimeout(() => {
          window.location.reload();
        }, 1000),
    });
  };

  const handleSave = () => {
    save();
    return;
  };

  return (
    <CompanyContainer>
      <div
        className="companydetail"
        style={{
          display: "flex",
          flexDirection: "row",
          paddingRight: "42px",
          marginBottom: "94.45px",
        }}
      >
        <CompanyComponent
          name={investeeName}
          address_line_1={countryOrigin}
          iconComponent={debtIcon}
        />
        <Debt
          initialData={{
            vatNumber,
            investeeName,
            countryOrigin,
            yourShare,
            scope1,
            scope2,
          }}
          isNewFacility={true}
          onFormDataChange={handleFormDataChange}
          handleSave={handleSave}
          errorMessage={errorMessage}
          setCurrentName={setInvesteeName}
          setCutOffAddress={setCountryOrigin}
        />
      </div>
    </CompanyContainer>
  );
};

export default AddDebt;
